import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

interface SearchComponentProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    style?: React.CSSProperties;
    size?: "small" | "middle" | "large";
    allowClear?: boolean;
    disabled?: boolean;
}

const SearchComponent = ({
	value,
	onChange,
	placeholder = "Ara",
	style,
	size = "large",
	allowClear = true,
	disabled = false,
}: SearchComponentProps) => {
	return (
		<Input
			allowClear={allowClear}
			disabled={disabled}
			size={size}
			placeholder={placeholder}
			prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
			style={style}
			value={value}
			onChange={(e) => onChange(e.target.value)}
		/>
	);
};

export default SearchComponent;
